<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-post"
    id="post-page"
  >
    <PageHeader />
    <div class="img-holder">
      <wpImage
        v-if="currentPage.featured_image_src"
        :data="currentPage.featured_image_src"
        size="extra_large"
        class="page-featuredimage animate-delay-03"
        lazy
        background
        placeholder
        data-key="1"
        v-observe-visibility="visibilityChanged"
        :class="[baseAnimation]"
      />
      <aside class="sidebar">
        <div
          v-if="
            currentPage.featured_image_src &&
              currentPage.featured_image_src.caption
          "
          class="img-description"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        >
          {{ currentPage.featured_image_src.caption }}
        </div>

        <Author
          :id="Number(currentPage.author)"
          :date="formattedDate"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        />
        <Categories
          v-if="currentPage.acf && currentPage.acf._categories"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          :categories="currentPage.acf._categories"
        />
        <Share
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        />
      </aside>
    </div>
    <main class="post-content content-two-row padding_large">
      <div class="content">
        <DynamicHtml
          class=""
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          role="content"
          >{{ currentPage.content.rendered }}</DynamicHtml
        >
        <RelatedEvent
          class="related-event"
          v-if="currentPage.acf && currentPage.acf.select_event"
          :id="currentPage.acf.select_event"
        />
      </div>
    </main>

    <RelatedPosts :data="relatedPostsData" />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Author from "@/components/blocks/AuthorBlock";
import Share from "@/components/blocks/ShareBlock";
import RelatedEvent from "@/components/blocks/SingleEvent";
import Categories from "@/components/blocks/CategoriesBlock";
import RelatedPosts from "@/components/modules/News";
import moment from "moment";
moment.locale("nb");

export default {
  name: "single-post",
  components: {
    WpImage,
    Author,
    Share,
    Categories,
    RelatedEvent,
    RelatedPosts
  },
  data() {
    return {
      isVisibleItem: {
        image: false,
        content: false
      }
    };
  },
  computed: {
    relatedPostsData() {
      return {
        news_category: this.currentPage.acf._categories,
        theme: "white",
        title: "Relaterte artikler"
      };
    },
    formattedDate() {
      // the bulk payload has post_date, wp/v2-fetched copies have date
      const date =
        this.currentPage &&
        (this.currentPage.post_date || this.currentPage.date);
      if (date) {
        return moment(date).format("DD. MMMM YYYY");
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";

#post-page {
  .img-holder {
    display: grid;
    grid-template-columns: 66% 33%;
    max-width: 1000px;
    margin: 0 auto;
  }
  .sidebar {
    padding-left: 30px;
  }
  .top-page-header {
    padding-top: 50px !important;
    .content {
      max-width: 1000px;
      margin: 0 auto;
      .excerpt {
        width: 60%;
        font-weight: 500;
        font-size: 20px;
      }
    }
  }
  .content-two-row {
    .content {
      max-width: 1000px;
      margin: 0 auto;
    }
    .html-content {
      width: 60%;
    }
  }
  @include mquery(767px) {
    .img-holder {
      grid-template-columns: 100%;
    }
    .sidebar {
      padding: 20px;
    }
    .top-page-header {
      padding-top: 0 !important;
      .content .excerpt {
        width: 100%;
      }
    }
    .content-two-row .html-content {
      width: 100%;
    }
  }
}

.related-event {
  @include mquery(1550px) {
    .event-footer {
      .column {
        max-width: 50%;
        width: 100%;
        padding: 20px;
      }
    }
    .event-block-link {
      display: flex;
      flex-direction: column;
      position: relative;
      justify-content: space-between;
      height: 100%;
      background: rgba(42, 46, 52, 1);
      padding-bottom: 0;
      text-decoration: none;
      transition: box-shadow 0.12s ease-in-out;
      &:hover {
        box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
      }
      .event-thumb {
        padding-bottom: 56.25%;
        position: relative;
        .bg-image {
          padding-bottom: 56.25%;
        }
      }
      .event-footer {
        display: flex;
        position: relative;
        .left {
          max-width: 50%;
        }
        .right {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          max-width: 50%;
        }
      }
    }
  }
}
</style>
